import __base_store from '@/store/__base_store'

/**
 * Store de subcategorías.
 */
export default __base_store({
	state: {
		model_name: 'sub_category',
		per_page: 25,
	},
})

